import React from "react";
import ProductPage from "./ProductPage";
import image from "../Images/product-heroes/expenses-hero.png";
import detailImage from "../Images/dashboards/admin-dashboard.png";

const product = {
  "id": "expenses",
  "title": "Expense Management",
  "headline": "Less paperwork.",
  "accent": "Clearer expense control.",
  "description": "Bring receipts, employee claims, approvals and reimbursements into one organized workflow. Give teams a clearer view of spending across your business.",
  "checks": [
    "Simple expense claims",
    "Approval workflows",
    "Spending visibility"
  ],
  "badge": "Expense claims, organized",
  "imageAlt": "Illustration of employees submitting and reviewing expense receipts",
  "summary": [
    {
      "icon": "receipt",
      "title": "Organized expense claims",
      "text": "Keep receipts and categories together."
    },
    {
      "icon": "shield",
      "title": "Clear approval processes",
      "text": "Route claims through your team."
    },
    {
      "icon": "chart",
      "title": "Understand spending",
      "text": "Review expenses across categories and teams."
    }
  ],
  "featuresTitle": "From receipt to reimbursement, keep it connected",
  "featuresSubtitle": "Give employees and managers a clearer way to handle business expenses.",
  "features": [
    {
      "title": "Mobile expense submission",
      "icon": "mobile",
      "text": "Help employees submit and track claims from an accessible interface.",
      "points": [
        "Mobile access",
        "Expense claim submission",
        "Approval status tracking"
      ]
    },
    {
      "title": "Receipts & categories",
      "icon": "receipt",
      "text": "Keep supporting documents and expense details organized.",
      "points": [
        "PDF and image receipts",
        "Travel and office expense categories",
        "Structured claim records"
      ]
    },
    {
      "title": "Approval workflows",
      "icon": "people",
      "text": "Route expense claims to the people responsible for reviewing them.",
      "points": [
        "Multi-level approvals",
        "Amount and category-based routing",
        "Manager notifications"
      ]
    },
    {
      "title": "Expense policies",
      "icon": "shield",
      "text": "Keep expense reviews aligned with your company rules.",
      "points": [
        "Configurable expense policies",
        "Policy checks",
        "Alerts for out-of-policy claims"
      ]
    },
    {
      "title": "Reports & analytics",
      "icon": "chart",
      "text": "Understand where your teams spend and spot patterns over time.",
      "points": [
        "Category-wise spending",
        "Department expense reports",
        "Spending trend insights"
      ]
    },
    {
      "title": "Reimbursements & integrations",
      "icon": "wallet",
      "text": "Connect approved claims with the wider finance workflow.",
      "points": [
        "Payroll and ERP integration",
        "Banking integration",
        "Expense activity audit trails"
      ]
    }
  ],
  "detailImageAlt": "BillPunch admin dashboard with workforce and financial reporting",
  "detailLabel": "Visibility for Your Finance Team",
  "detailTitle": "A clearer trail for every claim.",
  "detailText": "Keep expense submissions, approval decisions and reimbursement records connected. Employees can follow their requests while managers review spending in context.",
  "detailPoints": [
    "Keep supporting receipts with claims",
    "Follow approval and reimbursement progress",
    "Review spending across departments"
  ],
  "workflowTitle": "A straightforward path from claim to payment",
  "steps": [
    [
      "Set your policies",
      "Define categories, limits and approval rules."
    ],
    [
      "Submit expenses",
      "Employees add receipts and claim details."
    ],
    [
      "Review and approve",
      "Managers review claims against company policies."
    ],
    [
      "Reimburse and report",
      "Connect approved claims with finance and reporting."
    ]
  ],
  "cta": "Give expense management a simpler workflow."
};
product.image = image;
product.detailImage = detailImage;

const Expensemanagement = () => <ProductPage product={product} />;

export default Expensemanagement;
